/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { RouterProps } from 'react-router';

import SimpleMessagePage from 'components/SimpleMessagePage';

import useTranslate, {
  useMarkdownMultilineTranslate,
} from 'hooks/useTranslate/useTranslate';
import RestartButton from 'components/RestartButton';

const TextMeMyOfferDeadend: React.FC<RouterProps> = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();
  const t = useTranslate();

  return (
    <SimpleMessagePage
      headerTitle={'unified.offer.textMeMyOffer.deadendPage.title'}
      message={tMdMultiline('unified.offer.textMeMyOffer.deadendPage.message')}
    >
      <RestartButton>
        {t('unified.offer.textMeMyOffer.deadendPage.restartButton')}
      </RestartButton>
    </SimpleMessagePage>
  );
};

export default TextMeMyOfferDeadend;
